import { render, staticRenderFns } from "./RankingBookCard.vue?vue&type=template&id=020d265c&"
import script from "./RankingBookCard.vue?vue&type=script&lang=js&"
export * from "./RankingBookCard.vue?vue&type=script&lang=js&"
import style0 from "./RankingBookCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports